export class PracticePlace {
    practicePlaceKey?: number;
    postalCode: string;
    label: string;
    city: string;
    address: string;
    box: string;
    latitude: number;
    longitude: number;
    clubCode: string;
    department: string;
    region: string;
    country: string;

    constructor(postalCode: string = '', label: string = '', city: string = '', address: string = '', box: string = '', latitude: number = null, longitude: number = null, clubCode: string = '', department: string = '', region: string = '', country: string = '') {
        this.postalCode = postalCode;
        this.city = city;
        this.address = address;
        this.box = box;
        this.latitude = latitude;
        this.longitude = longitude;
        this.clubCode = clubCode;
        this.department = department;
        this.region = region;
        this.country = country;
        this.label = label;

    }
}

